import { c as _c } from "react/compiler-runtime";
import Switch from '@components/switch/Switch';
import { handleChangeFormName, handleOpenModelForm } from '@lib/store/slices/ComponentsSlice';
import { getDataForBookingLink } from '@lib/tools/_get_data_for_booking_link';
import { useDispatch, useSelector } from 'react-redux';
import style from './FlatBookButton.module.scss';
const FlatBookButton = t0 => {
  const $ = _c(17);
  const {
    flat,
    switchText
  } = t0;
  const dispatch = useDispatch();
  const {
    currentData,
    selectedBenefit
  } = useSelector(_temp);
  let t1;
  if ($[0] !== currentData || $[1] !== flat || $[2] !== selectedBenefit) {
    t1 = getDataForBookingLink(selectedBenefit, flat, currentData);
    $[0] = currentData;
    $[1] = flat;
    $[2] = selectedBenefit;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const data = t1;
  const minPrice = currentData?.currentMortgageBenefit?.mortgage?.minPrice;
  const firstPayment = currentData?.currentMortgageBenefit?.mortgage?.firstPayment;
  const enoughFirstPayment = selectedBenefit?.group === "mortgage" && firstPayment >= minPrice;
  const disableBooking = !enoughFirstPayment && selectedBenefit?.group === "mortgage";
  const bookingUrl = `/booking?flatId=${flat?.id}&firstPayment=${data?.firstPayment}&loanTerm=${data?.loanTerm}&benefitGuid=${data?.benefitGuid}&flatGuid=${flat?.guid}`;
  let t2;
  if ($[4] !== bookingUrl || $[5] !== disableBooking || $[6] !== flat?.bookingStatus || $[7] !== flat?.has_advertising_price) {
    t2 = flat?.bookingStatus === "active" && flat?.has_advertising_price !== 1 && <div className={`booking-button ${disableBooking && style.flatDescription__disabledBooking} ${style.flatDescription__booking}`}><Switch switchText={"\u0417\u0430\u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C"} black={true} type="link" href={bookingUrl} /></div>;
    $[4] = bookingUrl;
    $[5] = disableBooking;
    $[6] = flat?.bookingStatus;
    $[7] = flat?.has_advertising_price;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== dispatch) {
    t3 = () => {
      dispatch(handleOpenModelForm(true));
      dispatch(handleChangeFormName("flatForm"));
    };
    $[9] = dispatch;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== switchText || $[12] !== t3) {
    t4 = <Switch handleSwitch={t3} switchText={switchText} testId="flatFormOpen" />;
    $[11] = switchText;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t2 || $[15] !== t4) {
    t5 = <div className={style.flatDescription__switches}>{t2}{t4}</div>;
    $[14] = t2;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
export default FlatBookButton;
function _temp(state) {
  return state?.equalizer;
}